import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { configurationProfileSchema } from '../schemas/configuration-profile.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Requests the Configuration Profiles associated with a specific vehicle
 * @param vehicleId The vehicle ID for the vehicle whose Configuration Profiles are being requested
 * @returns The Configuration Profiles
 */
export function getConfigurationProfilesVehiclesId(
  this: unknown,
  vehicleId: string
) {
  const requestUrl = `${
    fleetEnvironment.resolve(this).configurationProfilesVehiclesUrl
  }/${vehicleId}`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(configurationProfileSchema),
      })
    )
  );
}
